import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SsBusyComponent } from '@blocks/busy/ss-busy/ss-busy.component';

@NgModule({
  imports: [CommonModule],
  exports: [SsBusyComponent],
  declarations: [SsBusyComponent],
})
export class SsBusyModule {}
